import {List} from 'immutable';
import isURL from 'validator/lib/isURL';
import isUUID from 'validator/lib/isUUID';

function nonNullValidator(attr, error) {
  const attribute = attr || '';
  if (attribute.length === 0 || attribute.size === 0) {
    return List([error]);
  }

  return null;
}

function validUUIDValidator(attr, error) {
  const attribute = attr || '';
  // only validate non-null case IDs
  if (attribute.length && !isUUID(attribute)) {
    return List([error]);
  }
  return null;
}

function validURLValidator(attr, error) {
  const attribute = attr || '';
  if (attribute.length && !isURL(attribute, {require_protocol: true})) {
    return List([error]);
  }
  return null;
}

function validDateRangeValidator(startDate, endDate) {
  // only validate if both dates are filled out
  if (typeof startDate === 'string' && typeof endDate === 'string') {
    if (new Date(startDate) > new Date(endDate)) {
      return ['Invalid date range - start date must come before end date'];
    }
  }

  return null;
}

/* oxlint-disable no-underscore-dangle */

export const standardSetModelValidators = {
  getTitle() {
    return nonNullValidator(this.getTitle(), 'Standard set name Required');
  },

  getDescription() {
    // description not a required field
    return null;
  },

  getAdoptionStatus() {
    return nonNullValidator(this.getAdoptionStatus(), 'Standard set adoption status required');
  },

  getStandardSetCreator() {
    const publisherChanges = this.__changeMap.getIn(
      ['__relationshipReplacements', 'standard_set_creator_v1'],
      null
    );

    if (publisherChanges === null) {
      return this.getStandardSetCreator().isEmpty()
        ? List(['1 publisher required for standard set'])
        : null;
    }

    const publisherId =
      typeof publisherChanges === 'string' ? publisherChanges : publisherChanges?.getId?.();

    return nonNullValidator(publisherId, '1 publisher required for standard set');
  },

  getCurriculumAreas() {
    const curriculumChanges = this.__changeMap.getIn(
      ['__relationshipReplacements', 'curriculum_areas_v1'],
      null
    );
    // this means a user edited a standard set but did not change the curriculum field
    if (!this.getCurriculumAreas().isEmpty() && !curriculumChanges) {
      return null;
    }
    return nonNullValidator(
      curriculumChanges,
      'At least 1 curriculum area(s) required for standard set'
    );
  },

  getSubjects() {
    const subjectChanges = this.__changeMap.getIn(
      ['__relationshipReplacements', 'authoring_subjects_v1'],
      null
    );
    // this means a user edited a standard set but did not change the subjects field
    if (!this.getAuthoringSubjects().isEmpty() && !subjectChanges) {
      return null;
    }
    return nonNullValidator(subjectChanges, 'At least 1 subject(s) required for standard set');
  },

  getCaseId() {
    return validUUIDValidator(this.getCaseId(), 'Standard set case ID must be a valid UUID');
  },

  getUri() {
    return validURLValidator(this.getUri(), 'Standard set Case URI must be a valid URL');
  },

  getOfficialSourceUrl() {
    return validURLValidator(
      this.getOfficialSourceUrl(),
      'Standard set Official source must be a valid URL'
    );
  },

  getStatusStartDate() {
    return validDateRangeValidator(this.getStatusStartDate(), this.getStatusEndDate());
  },
  getStatusEndDate() {
    return validDateRangeValidator(this.getStatusStartDate(), this.getStatusEndDate());
  }
};
